var React = require("react");

class Tables extends React.Component {
    
    constructor(){
        super();
    }
    
    render() {
        return <div>
                <button onClick={()=>this.props.history.push(`/exploreTable`)}>Explore Table</button>
                <button onClick={()=>this.props.history.push(`/placePartTable`)}>Add Part Table</button>
        </div>
    }
}

module.exports = Tables;
